import React from 'react';
import { Calendar, Image, Users } from 'lucide-react';

const OverviewSection = ({ events, news, gallery, organizations, users, setActiveTab }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        <button 
          onClick={() => {
            setTimeout(() => setActiveTab('eventsandnews'), 10);
          }}
          className="bg-white rounded-lg shadow p-4 sm:p-6 hover:shadow-lg hover:bg-gray-50 transition-all duration-300 w-full focus:outline-none active:bg-gray-100"
        >
          <div className="flex items-center">
            <Calendar className="w-6 h-6 sm:w-8 sm:h-8 text-red-600" />
            <div className="ml-3 sm:ml-4">
              <p className="text-xl sm:text-2xl font-semibold text-gray-900">{events.length + news.length}</p>
              <p className="text-sm sm:text-base text-gray-600">Events & News</p>
              <div className="flex gap-2 mt-1">
                <span className="text-xs text-gray-500">{events.length} event{events.length > 1 ? 's' : ''}</span>
                <span className="text-xs text-gray-400">•</span>
                <span className="text-xs text-gray-500">{news.length} news article{news.length > 1 ? 's' : ''}</span>
              </div>
            </div>
          </div>
        </button>

        <button 
          onClick={() => {
            setTimeout(() => setActiveTab('gallery'), 10);
          }}
          className="bg-white rounded-lg shadow p-4 sm:p-6 hover:shadow-lg hover:bg-gray-50 transition-all duration-300 w-full focus:outline-none active:bg-gray-100"
        >
          <div className="flex items-center">
            <Image className="w-6 h-6 sm:w-8 sm:h-8 text-green-600" />
            <div className="ml-3 sm:ml-4">
              <p className="text-xl sm:text-2xl font-semibold text-gray-900">{gallery.length}</p>
              <p className="text-sm sm:text-base text-gray-600">Gallery Images</p>
            </div>
          </div>
        </button>

        <button 
          onClick={() => {
            setTimeout(() => setActiveTab('organizations'), 10);
          }}
          className="bg-white rounded-lg shadow p-4 sm:p-6 hover:shadow-lg hover:bg-gray-50 transition-all duration-300 w-full focus:outline-none active:bg-gray-100"
        >
          <div className="flex items-center">
            <Users className="w-6 h-6 sm:w-8 sm:h-8 text-orange-600" />
            <div className="ml-3 sm:ml-4">
              <p className="text-xl sm:text-2xl font-semibold text-gray-900">{organizations.length}</p>
              <p className="text-sm sm:text-base text-gray-600">Organizations</p>
            </div>
          </div>
        </button>

        <button 
          onClick={() => {
            setTimeout(() => setActiveTab('users'), 10);
          }}
          className="bg-white rounded-lg shadow p-4 sm:p-6 hover:shadow-lg hover:bg-gray-50 transition-all duration-300 w-full focus:outline-none active:bg-gray-100"
        >
          <div className="flex items-center">
            <Users className="w-6 h-6 sm:w-8 sm:h-8 text-purple-600" />
            <div className="ml-3 sm:ml-4">
              <p className="text-xl sm:text-2xl font-semibold text-gray-900">{users.length}</p>
              <p className="text-sm sm:text-base text-gray-600">Admin Users</p>
            </div>
          </div>
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow">
          <div className="p-4 sm:p-6 border-b border-gray-200">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900">Recent Events</h3>
          </div>
          <div className="p-4 sm:p-6">
            {events.slice(0, 5).map((event) => (
              <div key={event._id} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-b-0">
                <div>
                  <p className="text-sm sm:text-base font-medium text-gray-900">{event.title}</p>
                  <p className="text-xs sm:text-sm text-gray-600">{event.date ? new Date(event.date).toISOString().split('T')[0] : '--'}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow">
          <div className="p-4 sm:p-6 border-b border-gray-200">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900">Recent News</h3>
          </div>
          <div className="p-4 sm:p-6">
            {news.slice(0, 5).map((article) => (
              <div key={article._id} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-b-0">
                <div>
                  <p className="text-sm sm:text-base font-medium text-gray-900">{article.title}</p>
                  <p className="text-xs sm:text-sm text-gray-600">{new Date(article.createdAt).toLocaleDateString()}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewSection;